<template>
  <span class="inline-flex max-w-full items-center gap-1.5 rounded-md px-2 py-1 text-xs font-semibold ring-1 ring-inset" :class="toneClasses">
    <span class="size-1.5 shrink-0 rounded-full" :class="dotClasses" aria-hidden="true" />
    <span class="truncate">{{ label }}</span>
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  label: {
    type: String,
    required: true
  },
  tone: {
    type: String,
    default: 'slate'
  }
})

const toneClasses = computed(() => ({
  green: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  blue: 'bg-blue-50 text-blue-700 ring-blue-200',
  amber: 'bg-amber-50 text-amber-700 ring-amber-200',
  red: 'bg-red-50 text-red-700 ring-red-200',
  violet: 'bg-violet-50 text-violet-700 ring-violet-200',
  slate: 'bg-slate-100 text-slate-700 ring-slate-200'
})[props.tone] || 'bg-slate-100 text-slate-700 ring-slate-200')

const dotClasses = computed(() => ({
  green: 'bg-emerald-500',
  blue: 'bg-blue-500',
  amber: 'bg-amber-500',
  red: 'bg-red-500',
  violet: 'bg-violet-500',
  slate: 'bg-slate-400'
})[props.tone] || 'bg-slate-400')
</script>
